export default "__VITE_ASSET__BchFfm0O__"